"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortEventsByPrevious = exports.sortEventsByTimeStamp = exports.dedupeOrderEvents = void 0;
/**
 * Removes duplicate events for the list of events provided.
 * Dedups based on event id. Open to extension
 * @param events OrderEvent[]
 * @returns OrderEvent[]
 */
function dedupeOrderEvents(events, by = 'id') {
    const processedEvents = {};
    const result = [];
    for (let index = 0; index < events.length; index++) {
        const event = events[index];
        // Already added to results. skip this event object
        if (processedEvents[event[by]]) {
            continue;
        }
        processedEvents[event[by]] = true;
        result.push(event);
    }
    return result;
}
exports.dedupeOrderEvents = dedupeOrderEvents;
/**
 * Sort events in place. Note: This is not a pure function. it mutates source array for performance
 * @param events OrderEvent[]
 * @returns OrderEvent[]
 */
function sortEventsByTimeStamp(events) {
    return events.sort((a, b) => a.timestamp - b.timestamp);
}
exports.sortEventsByTimeStamp = sortEventsByTimeStamp;
/**
 * Group events by previous.
 * @param events OrderEvent[]
 * @returns Dictionary<OrderEvent[]>
 */
function groupEventsByPrevious(events) {
    return events.reduce((acc, event) => {
        if (acc[event.previous] === undefined)
            acc[event.previous] = [];
        acc[event.previous].push(event);
        return acc;
    }, {});
}
/**
 * Sort order events by previous.
 * @param sortedEventsByTimeStamp OrderEvent[]
 * @returns OrderEvent[]
 */
function sortEventsByPrevious(sortedEventsByTimeStamp) {
    const sortedEvents = [];
    if (sortedEventsByTimeStamp.length <= 1)
        return sortedEventsByTimeStamp;
    // FIXME: Adding a temporary patch for fixing Online store issue
    // If events graph is broken we are relying on sort by timestamp itself
    // Condition for that is there should be no duplicate timestamps.
    const uniqueEventsByTimestamp = dedupeOrderEvents(sortedEventsByTimeStamp, 'timestamp');
    if (uniqueEventsByTimestamp.length === sortedEventsByTimeStamp.length) {
        return sortedEventsByTimeStamp;
    }
    const groupedEvents = groupEventsByPrevious(sortedEventsByTimeStamp);
    const allIds = sortedEventsByTimeStamp.map(event => event.id);
    // groupedEvents['undefined'] should be the root of the events graph
    // if we are missing e.g. INITIATE_ORDER event, or ORDER_PAYMENT
    // which means there will be a previous event ID not existing in the events array (unit tested)
    // Hence we will add all  events whose previous are not in the set as the starting events
    Object.keys(groupedEvents).forEach(key => {
        if (!allIds.includes(key))
            sortedEvents.push(...groupedEvents[key]);
    });
    let index = 0;
    while (index < sortedEvents.length) {
        const currentEvent = sortedEvents[index];
        if (groupedEvents[currentEvent.id])
            sortedEvents.push(...groupedEvents[currentEvent.id]);
        index = index + 1;
    }
    return sortedEvents;
}
exports.sortEventsByPrevious = sortEventsByPrevious;
//# sourceMappingURL=orderEventsSorting.js.map